import { registerQuery } from 'data-fetching-client';
import getLang from 'I18n/utils/getLang';
import * as t from 'ts-schema';
import { getEcosystemClient, ecosystemAdminClient } from 'marketplace-ui-common/clients/ecosystemClient';
import { getQuickFetch } from 'marketplace-ui-common/utils/earlyRequests';
import { detailsResponseSchema } from 'marketplace-ui-client-types/ecosystem-service-v1/schema';
export const APP_DETAILS_PREVIEW_QUERY = registerQuery({
  fieldName: 'appDetails',
  args: ['appContext', 'slug', 'language'],
  fetcher: ({
    appContext,
    slug,
    language
  }) => {
    return getQuickFetch(`details:preview:${slug}`).catch(() => {
      const client = appContext === 'admin-preview' ? ecosystemAdminClient : getEcosystemClient(appContext);
      const options = {
        query: {
          slug,
          language: language || getLang()
        }
      };
      return client.get('apps/details/preview', options).then(response => t.assert(detailsResponseSchema, response));
    });
  }
});